import React from "react";
import RateCard from "./RateCard";

export default function RateResultsGrid({
  rates,
  lspArray,
  packageType,
  pickupPincode,
  deliveryPincode,
  boxes,
  expandedCards,
  onToggleExpand,
  insuranceOption,
  paymentMode,
  codAmount,
  invoiceValue,
  selfDropOption,
  showAdvanced,
}) {
  return (
    <div className="flex flex-wrap gap-4 items-start">
      {rates.map((rate, index) => {
        // Debug: Log the rate.lspId to see what service names are coming from API
        console.log("Rate LSP ID:", rate.lspId, "Service:", rate.service);
        
        // Enhanced matching logic for IndiaPost services
        let lspObject = lspArray.find((lsp) => lsp.lspId === rate.lspId);
        
        // If no exact match found, try to match IndiaPost services by checking if the service contains "India" or "Post"
        if (!lspObject && (rate.lspId?.toLowerCase().includes('india') || rate.lspId?.toLowerCase().includes('post'))) {
          lspObject = lspArray.find((lsp) => 
            lsp.lspId.toLowerCase().includes('india') || lsp.lspId.toLowerCase().includes('post')
          );
        }
        
        // Debug: Log if we found a matching LSP object
        console.log("Found LSP Object:", lspObject);
        return (
          <RateCard
            key={index}
            rate={rate}
            lspObject={lspObject}
            packageType={packageType}
            pickupPincode={pickupPincode}
            deliveryPincode={deliveryPincode}
            boxes={boxes}
            expanded={!!expandedCards[index]}
            onToggleExpand={onToggleExpand}
            index={index}
            insuranceOption={insuranceOption}
            paymentMode={paymentMode}
            codAmount={codAmount}
            invoiceValue={invoiceValue}
            selfDropOption={selfDropOption}
            showAdvanced={showAdvanced}
          />
        );
      })}
    </div>
  );
}
